import React from 'react';
import { makeStyles } from '@material-ui/core';
import ButtonBase from '../../Buttons/ButtonBase';
import { Link as LinkScroll } from 'react-scroll';
import './WebinarSlogan.scss';

const useStyles = makeStyles({
    buttonStyle: {
        minWidth: 'inherit',
        width: 322,
    },
    // '@media screen and (max-width: 1000px)': {
    //     buttonStyle: {
    //         minWidth: 'inherit',
    //         width: 296,
    //     },
    //     linkScroll: {
    //         width: '100%',
    //         display: 'contents'
    //     }
    // },
    // '@media screen and (max-width: 499.98px)': {
    //     buttonStyle: {
    //         width: '100%',
    //         display: 'inherit'
    //     },
    //     linkScroll: {
    //         display: 'block'
    //     }
    // }
})

const WebinarSlogan = () => {

    const classes = useStyles()

    return ( 
        <section className="wbSl">
            <div className="wbSl_container">
               <div className="wbSl_containerImg">
                    <img
                        className="wbSl_containerImg-img"
                        src='/img/Webinar/Slogan/guys.png'
                        alt='guys'
                    />
               </div>
               <div className="wbSl_containerText">
                   <p className="wbSl_containerText-title">Abogado, es momento de digitalizarse</p>
                   <p className="wbSl_containerText-info">
                       <strong>El mundo está cambiando</strong> a pasos acelerados, no pierda la <strong>oportunidad</strong> de
                       unirse al cambio.
                   </p>
                   <LinkScroll
                        to="webinarForm"
                        smooth="true"
                        duration={500}
                        offset={-60}
                        className={classes.linkScroll}
                    >
                        <ButtonBase
                            type="submit"
                            variant="secondary"
                            buttonStyle={classes.buttonStyle}
                        >
                            Quiero asistir al webinar
                        </ButtonBase>
                    </LinkScroll>
               </div>
            </div>
        </section>
     );
}
 
export default WebinarSlogan;